const HOUR_MS = 3600000;

export function summarizeSessions(sessions, now = Date.now()) {
  const ended = sessions.filter((s) => s.startedAt && s.endedAt);
  const hoursTotal =
    ended.reduce((sum, s) => sum + (new Date(s.endedAt) - new Date(s.startedAt)), 0) / HOUR_MS;
  const labs = new Set(sessions.map((s) => s.space_id).filter(Boolean));
  const cutoff = now - 30 * 24 * HOUR_MS;
  const last30 = sessions.filter(
    (s) => s.startedAt && new Date(s.startedAt).getTime() >= cutoff
  ).length;
  return {
    visits: sessions.length,
    hours: Math.round(hoursTotal * 10) / 10,
    labsVisited: labs.size,
    last30,
  };
}

export function activeSessionOf(sessions) {
  return sessions.find((s) => s.status === "active") || null;
}
